module.exports = __webpack_public_path__ + "img/arrow-up.c16e4cde.svg";